/**
 * The Daily Air Quality Index colour ramp, and the sprite names built from it.
 *
 * Its own module for the same reason festival-colours.ts is: both icons.ts and
 * map-style.ts need these names, and importing icons.ts into map-style.ts would
 * drag a canvas-drawing module into a file that is compiled and evaluated by
 * scripts/test-map-expressions.mjs in Node, where there is no document.
 *
 * The ten colours are the design handoff's, which are the official DAQI scale:
 * three greens, three yellow-oranges, three reds, and purple for Very High.
 * Generated names rather than ten literals, so the ramp is stated once — the
 * mistake that costs is a sprite registered in icons.ts and forgotten in
 * REPLACES_CIRCLE, which draws the pin on top of a coloured dot.
 */
export const DAQI_COLOURS = [
  '#9cff9c', // 1  Low
  '#31ff00', // 2  Low
  '#31cf00', // 3  Low
  '#ffff00', // 4  Moderate
  '#ffcf00', // 5  Moderate
  '#ff9a00', // 6  Moderate
  '#ff9292', // 7  High
  '#ff0000', // 8  High
  '#990000', // 9  High
  '#ce30ff', // 10 Very High
] as const;

/** The sprite name for one index. Must match the provider's `air-N`. */
export function airIconName(index: number): string {
  return `air-${index}`;
}

/** Every index sprite, for the lists that must not miss one. */
export function airIconNames(): string[] {
  return DAQI_COLOURS.map((_, i) => airIconName(i + 1));
}
